import { JSX } from 'react';
import WindowBar from '../common/windowBar/windowBar';
import { TodoTask } from '../todolist/add-todo/addTodoList';
import editIcon from '../assets/images/svgs/pencil-edit.svg';
import EditTodoContent from './editTodoContent';
import './editTodo.css';

const EditTodo = ({todo, setClosePage}: {todo: TodoTask, setClosePage:()=>void}): JSX.Element => {
  
    return (
        <div className='editTodo-outter outter-container'>
            <div className='pixel-container-back'/>
            <div className='pixel-container-top'>
                <div className='editTodo-inner'>
                    <WindowBar IconSrc={editIcon} title='Todo Edit' onClick={setClosePage}/>
                    <div className='main-pixel-container page-content'>
                        <EditTodoContent todo={todo} setClosePage={setClosePage}/>
                    </div>
                </div>
            </div>
        </div>
    ); 
};
    
export default EditTodo;